import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { ShopBreadcrumbs } from './ShopBreadcrumbs';
import { ShopCarousel } from './ShopCarousel';
import { ShopGrid } from './ShopGrid';
import { ShopList } from './ShopList';

import styles from './styles/ShopWrapper.scss';

function ShopWrapperComponent({ landingPage }) {
    return (
        <React.Fragment>
            <ShopBreadcrumbs landingPage={landingPage} />
            <h1 className={styles.title} data-tn={`page-title-${landingPage.title}`}>
                {landingPage.title}
            </h1>
            {!!landingPage.description && (
                <p className={styles.description}>{landingPage.description}</p>
            )}
            <ShopCarousel landingPage={landingPage} />
            <ShopGrid landingPage={landingPage} />
            <ShopList landingPage={landingPage} />
        </React.Fragment>
    );
}

ShopWrapperComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopWrapper = createFragmentContainer(ShopWrapperComponent, {
    landingPage: graphql`
        fragment ShopWrapper_landingPage on LandingPage {
            ...ShopBreadcrumbs_landingPage
            ...ShopCarousel_landingPage
            ...ShopGrid_landingPage
            ...ShopList_landingPage
            title
            description
        }
    `,
});
